export const useRegex = ()=>{

    const alphaNumericWithSpaces = /^[a-zA-Z-0-9][a-zA-Z-0-9 ]+[a-zA-Z-0-9]$/
    const alphaWithSpaces = /^[ña-zÑA-Z ]*$/
    const localPhoneNumber = /^[0-9]\d*?$/
    const password = /^.{6,15}$/
    const address = /^[a-zA-Z-0-9#., ]{1,50}$/
    const description =  /^[a-zA-Z-0-9#., ]{0,50}$/
    const zipCode = /^[0-9]{5,6}$/
    const specialCharacters = /^[aA-zZ\s]+$/

    const validRegex=(string)=>{
        if(string.match(alphaNumericWithSpaces)){
            return true;
        }else{
            return false;
        }
    }

    const isAlphaNumericWithSpaces = (string)=>{
        if(string.match(alphaNumericWithSpaces)){
            return true;
        }else{
            return false;
        }
    }

    const dateIsNotGreaterThan=(date,maxDate)=>{
        if(date >  maxDate){return false}
        return true;
    }
    
    const dateIsNotLowerThan=(date,minDate)=>{
        if(date <  minDate){return false}
        return true;   
    }

    const isValidAge = (value)=>{
        if(value == ''){
            return false;
        }
        const fecha = new Date();
        const hoy = fecha.getFullYear()+'-'+(fecha.getMonth()+1)+'-'+fecha.getDate();
        const minYear = fecha.getFullYear() - 130;
        let dateParse = Date.parse(value);
        let date = new Date(dateParse);
        let actualYear = date.getFullYear()
        // let validDate = isDate(value);
        let minDate =  fecha.getFullYear() - 14 +'-'+(fecha.getMonth()+1)+'-'+fecha.getDate();
        let dateGreaterThan = dateIsNotGreaterThan(value,minDate);
        let dateLowerThan = dateIsNotLowerThan(actualYear,minYear);
       // if(validDate == false){return validDate;}
        if(dateGreaterThan == false){return dateGreaterThan;}
        if(dateLowerThan == false){return dateLowerThan;}
        return true
    }

    return {
        alphaNumericWithSpaces,
        description,
        localPhoneNumber,
        alphaWithSpaces,
        password,
        address,
        zipCode,
        isAlphaNumericWithSpaces,
        isValidAge,
        specialCharacters
    }

}